module.exports = __webpack_public_path__ + "img/Index／Arrowldown／default.f3fdb6ec.svg";